import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import * as matchesActions from "../../../../../_actions/matchesActions";
import getMemberProfileById from "../../../../../_selectors/matchesSelectors/getMemberProfileById";

class UserWrapper extends Component {
  componentDidMount() {
    const { user, getProfileById } = this.props;
    getProfileById(user);
  }

  render() {
    const { profile } = this.props;
    if (!profile) {
      return null;
    }
    return (
      <Link
        to={`/view-profile/${profile.id}`}
        className={
          profile.status === null
            ? "list-contacts-item contact-away"
            : profile.status === "online"
              ? "list-contacts-item contact-online"
              : "list-contacts-item contact-away"
        }
        title={`View ${profile.name}'s Profile`}
      >
        <img src={profile.imageURL} alt={profile.name} /> {profile.name}
      </Link>
    );
  }
}
const mapStateToProps = (state, ownProps) => ({
  profile: getMemberProfileById(state, ownProps.user)
});
const mapDispatchToProps = dispatch => ({
  getProfileById: profileId =>
    dispatch(matchesActions.getMatchedMemberProfile(profileId))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserWrapper);



// WEBPACK FOOTER //
// ./src/_components/Profile/Home/FollowList/UserWrapper/index.js